// Wall Week — PWA helpers: register service worker and expose install prompt.

let deferredPrompt = null;
const listeners = new Set();

function emit() {
  listeners.forEach((cb) => {
    try {
      cb(Boolean(deferredPrompt));
    } catch (_) {}
  });
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // Silent fail: SW is a progressive enhancement.
        console.warn("[PWA] SW registration failed", err);
      });
  });

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    emit();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    emit();
  });
}

export function canInstall() {
  return Boolean(deferredPrompt);
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function onInstallAvailableChange(cb) {
  listeners.add(cb);
  cb(Boolean(deferredPrompt));
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  emit();
  try {
    promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    return choice; // { outcome: "accepted" | "dismissed" }
  } catch (_) {
    return { outcome: "dismissed" };
  }
}

export function isIOS() {
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  return /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}
